function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c6bba8;\n      }\n\n      .cls-2 {\n        fill: #ddd8bc;\n      }\n\n      .cls-3 {\n        fill: #6cb33f;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #183e6d;\n      }\n\n      .cls-6 {\n        stroke-width: .6px;\n      }\n\n      .cls-6, .cls-7, .cls-8 {\n        fill: #9baccf;\n        stroke: #9baccf;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-9 {\n        fill: #81be5a;\n      }\n\n      .cls-10 {\n        fill: #9bcb7c;\n      }\n\n      .cls-11 {\n        fill: #bcbcbc;\n      }\n\n      .cls-7 {\n        stroke-width: .95px;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        stroke-width: .63px;\n      }\n    "), /*#__PURE__*/React.createElement("symbol", {
  id: "Tree_1_Small",
  "data-name": "Tree 1 Small",
  viewBox: "0 0 44.68 44.27"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M15.23,5.84c.18-1.51,1.04-2.97,2.39-3.68,1.35-.71,3.16-.54,4.22.56.92-1.26,2.28-2.28,3.83-2.48,1.55-.2,3.27.57,3.88,2.01,2.27.44,3.79,3.17,2.96,5.33-.13.32-.29.63-.38.97-.08.31-.07.63-.12.95-.13.93-.66,1.77-1.28,2.48-1.4,1.62-3.3,2.76-5.31,3.47-2.15.76-4.58,1.05-6.67.15-1.71-.73-3.16-2.45-3.26-4.36-.04-.67.19-1.31.15-1.99-.07-1.19-.56-2.19-.41-3.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M17.23,12.9c-.07-1.19-.56-2.19-.41-3.43.18-1.51,1.04-2.97,2.39-3.68,1.35-.71,3.16-.54,4.22.56.92-1.26,2.28-2.28,3.83-2.48,1.55-.2,3.27.57,3.88,2.01.58.11,1.11.37,1.56.74.29-2-1.13-4.19-3.15-4.58C28.94.6,27.22-.17,25.67.03c-1.55.2-2.91,1.21-3.83,2.48-1.05-1.1-2.87-1.27-4.22-.56-1.35.71-2.2,2.17-2.39,3.68-.15,1.23.34,2.24.41,3.43.04.67-.18,1.32-.15,1.99.06,1.24.7,2.4,1.61,3.26.05-.47.15-.93.12-1.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M38.44,36.52c1.93-.2,3.59-2.1,3.32-4.03,1.29-.17,2.44-1.15,2.8-2.41.36-1.25-.1-2.7-1.1-3.52.91-.56,1.15-1.88.73-2.87-.42-.99-1.34-1.68-2.31-2.15-2.84-1.37-6.43-1.04-8.97.83-.25.18-.48.38-.76.5-.35.16-.75.19-1.12.3-1.48.44-2.34,2.1-2.35,3.65-.01,1.55.62,3.02,1.27,4.43.79,1.74,2.41,1.69,3.79,2.7,1.57,1.16,2.48,2.8,4.73,2.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M43.45,26.55c.91-.56,1.15-1.88.73-2.87-.42-.99-1.34-1.68-2.31-2.15-.89-.43-1.86-.69-2.84-.79.77.45,1.45,1.07,1.8,1.88.42.99.19,2.31-.73,2.87,1.01.82,1.46,2.27,1.1,3.52-.36,1.25-1.5,2.24-2.8,2.41.26,1.82-1.22,3.63-3.02,3.98.82.71,1.69,1.25,3.05,1.11,1.93-.2,3.59-2.1,3.32-4.03,1.29-.17,2.44-1.15,2.8-2.41.36-1.25-.1-2.7-1.1-3.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M2.13,25.26c-.71,1.31-.54,3.04.4,4.19-1.26,1.14-2.04,2.81-2.11,4.51-.06,1.42.47,2.99,1.73,3.65,1.22.64,2.69.26,4.01-.13-.4.84-.18,1.88.38,2.61.56.73,1.43,1.19,2.32,1.44,1.25.35,2.63.33,3.79-.23,1.16-.56,2.07-1.71,2.18-3,1.16.52,2.57.21,3.58-.55,1.01-.77,1.66-1.93,2.05-3.14.48-1.48.61-3.11.13-4.6-.48-1.48-1.63-2.79-3.12-3.24.22-.87.43-1.83.03-2.62-.38-.75-1.2-1.14-1.98-1.47-1.67-.7-3.43-1.3-5.24-1.29-1.99.01-2.83,1.01-4.43,1.8-1.41.7-2.79.35-3.73,2.07Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M17.47,24.68c.08.02.15.05.22.08-.03-.16-.07-.32-.13-.47-.03.13-.06.26-.1.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M20.46,32.52c-.39,1.21-1.04,2.37-2.05,3.14-1.01.77-2.43,1.07-3.58.55-.11,1.29-1.01,2.44-2.18,3-1.16.56-2.55.59-3.79.23-.89-.25-1.75-.71-2.32-1.44-.56-.73-.78-1.78-.38-2.61-1.32.39-2.79.77-4.01.13-.9-.47-1.43-1.41-1.64-2.43-.05.28-.08.57-.1.86-.06,1.42.47,2.99,1.73,3.65,1.22.64,2.69.26,4.01-.13-.4.84-.18,1.88.38,2.61.56.73,1.43,1.19,2.32,1.44,1.25.35,2.63.33,3.79-.23,1.16-.56,2.07-1.71,2.18-3,1.16.52,2.57.21,3.58-.55,1.01-.77,1.66-1.93,2.05-3.14.38-1.17.54-2.42.36-3.63-.07.53-.2,1.05-.36,1.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M2.53,27.37c-.33-.4-.56-.87-.7-1.37-.19.68-.18,1.42,0,2.11.21-.26.44-.51.69-.73Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M3.68,7.96c-.36.37-.73.78-.82,1.29-.09.51.22,1.12.74,1.16C1.77,11.16.39,12.9.08,14.85c-.16,1.02-.05,2.07.15,3.09.21,1.05.81,2.31,1.88,2.27.22,0,.45-.08.67-.02.49.13.6.75.72,1.24.35,1.54,1.64,2.83,3.18,3.18,1.54.35,3.26-.26,4.24-1.5.14-.18.29-.39.51-.47.34-.12.7.12,1.01.31,1.45.93,3.33,1.14,4.94.55,1.61-.59,2.92-1.96,3.44-3.59,1.65-1.1,2.62-3.14,2.43-5.12-.19-1.97-1.54-3.79-3.37-4.55.72-.65.86-1.79.5-2.69-.37-.9-1.16-1.57-2.04-1.99-1.04-.49-2.22-.67-3.36-.5-.36.05-.71.14-1.07.11-.36-.03-.7-.17-1.04-.28-1.63-.51-3.49-.17-4.87.82-.79.56-.98.86-1.81,1.05-1.04.24-1.68.37-2.49,1.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M23.24,14.8c-.14-1.48-.94-2.88-2.1-3.8.13.39.23.8.27,1.21.19,1.97-.78,4.02-2.43,5.12-.51,1.64-1.82,3.01-3.44,3.59-1.61.59-3.5.38-4.94-.55-.31-.2-.66-.44-1.01-.31-.22.08-.36.28-.51.47-.98,1.24-2.7,1.85-4.24,1.5-.48-.11-.93-.31-1.34-.57.35,1.54,1.64,2.82,3.17,3.17,1.54.35,3.26-.26,4.24-1.5.14-.18.29-.39.51-.47.34-.12.7.12,1.01.31,1.45.93,3.33,1.14,4.94.55,1.61-.59,2.92-1.96,3.44-3.59,1.65-1.1,2.62-3.14,2.43-5.12Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M4.99,12.68c-1.41.06-2.49,1.62-2.21,3s1.74,2.36,3.15,2.27c.47-.03.97-.19,1.24-.57.21-.29.25-.67.27-1.03.03-.62,0-1.25-.11-1.86.95.07,1.91-.56,2.22-1.47.23-.68.25-1.62.94-1.84.39-.12.81.09,1.21.05.54-.05.94-.53,1.21-1.01.26-.47.45-1.05.22-1.53-.32-.68-1.24-.77-1.99-.77-1.12,0-2.23.01-3.35.02-1.66,0-1.61.64-2.12,1.87-.4.96-1.49,1.69-.68,2.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M23.01,23.24c-.51.05-1.06.14-1.45.47s-.54,1.01-.17,1.36c-1.89-.58-4.06-.11-5.54,1.2-.78.69-1.36,1.57-1.84,2.48-.51.95-.85,2.3,0,2.95.18.14.4.23.53.41.3.41-.01.96-.24,1.41-.71,1.41-.54,3.23.43,4.48.97,1.25,2.68,1.87,4.23,1.54.23-.05.47-.12.69-.04.34.12.47.54.58.88.53,1.63,1.85,2.99,3.47,3.57,1.62.57,3.5.35,4.94-.59,1.97.2,4.02-.76,5.13-2.4s1.22-3.91.29-5.66c.97-.05,1.81-.84,2.09-1.76.29-.93.1-1.95-.31-2.83-.49-1.04-1.29-1.93-2.28-2.52-.31-.19-.64-.35-.9-.6-.26-.25-.43-.58-.63-.88-.93-1.43-2.59-2.35-4.28-2.46-.97-.07-1.3.04-2.06-.34-.95-.48-1.53-.79-2.68-.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M33.76,40.96c.83-1.24,1.1-2.82.79-4.27-.14.39-.33.76-.56,1.1-1.11,1.65-3.16,2.61-5.13,2.4-1.44.94-3.32,1.16-4.94.59s-2.94-1.93-3.47-3.57c-.11-.35-.24-.76-.58-.88-.22-.08-.46-.01-.69.04-1.55.34-3.26-.29-4.23-1.54-.3-.39-.52-.83-.67-1.29-.7,1.41-.53,3.22.44,4.46.97,1.25,2.68,1.87,4.23,1.54.23-.05.47-.12.69-.04.34.12.47.54.58.88.53,1.63,1.85,2.99,3.47,3.57,1.62.57,3.5.35,4.94-.59,1.97.2,4.02-.76,5.13-2.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M21.49,29.42c-1.13-.85-2.95-.33-3.61.91-.66,1.25-.16,2.93.99,3.75.38.28.87.47,1.32.35.35-.09.62-.35.86-.62.42-.46.79-.97,1.1-1.51.69.66,1.83.78,2.65.28.61-.38,1.22-1.1,1.89-.82.38.16.57.58.9.81.45.31,1.07.19,1.58-.01.5-.2,1.02-.52,1.15-1.04.18-.73-.46-1.38-1.05-1.86-.87-.71-1.73-1.41-2.6-2.12-1.29-1.05-1.65-.53-2.83.1-.92.49-2.23.36-2.36,1.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M29.49,6.49c-.51.05-1.06.14-1.45.47-.39.33-.54,1.01-.17,1.36-1.89-.58-4.06-.11-5.54,1.2-.78.69-1.36,1.57-1.84,2.48-.51.95-.85,2.3,0,2.95.18.14.4.23.53.41.3.41-.01.96-.24,1.41-.71,1.41-.54,3.23.43,4.48.97,1.25,2.68,1.87,4.23,1.54.23-.05.47-.12.69-.04.34.12.47.54.58.88.53,1.63,1.85,2.99,3.47,3.57,1.62.57,3.5.35,4.94-.59,1.97.2,4.02-.76,5.13-2.4,1.11-1.65,1.22-3.91.29-5.66.97-.05,1.81-.84,2.09-1.76.29-.93.1-1.95-.31-2.83-.49-1.04-1.29-1.93-2.28-2.52-.31-.19-.64-.35-.9-.6-.26-.25-.43-.58-.63-.88-.93-1.43-2.59-2.35-4.28-2.46-.97-.07-1.3.04-2.06-.34-.95-.48-1.53-.79-2.68-.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M40.25,24.21c.83-1.24,1.1-2.82.79-4.27-.14.39-.33.76-.56,1.1-1.11,1.65-3.16,2.61-5.13,2.4-1.44.94-3.32,1.16-4.94.59-1.62-.57-2.94-1.93-3.47-3.57-.11-.35-.24-.76-.58-.88-.22-.08-.46-.01-.69.04-1.55.34-3.26-.29-4.23-1.54-.3-.39-.52-.83-.67-1.29-.7,1.41-.53,3.22.44,4.46.97,1.25,2.68,1.87,4.23,1.54.23-.05.47-.12.69-.04.34.12.47.54.58.88.53,1.63,1.85,2.99,3.47,3.57,1.62.57,3.5.35,4.94-.59,1.97.2,4.02-.76,5.13-2.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M27.51,10.97c-1.13-.85-2.95-.33-3.61.91s-.16,2.93.99,3.75c.38.28.87.47,1.32.35.35-.09.62-.35.86-.62.42-.46.79-.97,1.1-1.51.69.66,1.83.78,2.65.28.61-.38,1.22-1.1,1.89-.82.38.16.57.58.9.81.45.31,1.07.19,1.58-.01.5-.2,1.02-.52,1.15-1.04.18-.73-.46-1.38-1.05-1.86-.87-.71-1.73-1.41-2.6-2.12-1.29-1.05-1.65-.53-2.83.1-.92.49-2.23.36-2.36,1.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M10.02,19.2c-.58.36-1.14.78-1.49,1.36-.76,1.25-.36,2.85.13,4.23-1.71.59-2.22,3.08-1.13,4.53,1.08,1.45,3.22,1.82,4.93,1.21,1.21,1.21,2.97,1.84,4.67,1.68,1.7-.16,3.31-1.12,4.27-2.54.19-.29.39-.61.71-.74.27-.1.57-.04.86-.03.98.04,1.92-.51,2.5-1.3s.84-1.77.9-2.75c.03-.48.02-.98.16-1.44.1-.34.29-.65.42-.97.53-1.27.26-2.8-.57-3.89-.83-1.09-2.17-1.75-3.54-1.86-.72-1.37-2.18-2.33-3.72-2.43-2.28-.15-3.08,1.19-4.39,2.63-1.09,1.2-3.28,1.43-4.72,2.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M11.21,27.15c-.5-1.38-.9-3-.14-4.25.35-.58.92-1.01,1.5-1.37,1.44-.91,3.64-1.14,4.73-2.35,1.31-1.44,2.11-2.8,4.4-2.64,1.55.11,3.02,1.07,3.74,2.45.59.05,1.17.2,1.71.44-.14-.5-.38-.98-.69-1.39-.83-1.1-2.18-1.76-3.55-1.88-.72-1.38-2.19-2.34-3.74-2.45-2.29-.15-3.09,1.2-4.4,2.64-1.09,1.2-3.29,1.44-4.73,2.35-.58.36-1.14.79-1.5,1.37-.76,1.26-.36,2.87.14,4.25-1.72.59-2.23,3.09-1.14,4.56.49.66,1.19,1.09,1.97,1.32-.12-1.28.49-2.63,1.7-3.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M26.39,18.58c-.14-.18-.29-.35-.46-.51.03.55-.05,1.1-.26,1.61-.14.33-.32.64-.42.97-.14.46-.13.96-.16,1.44-.06.98-.32,1.96-.9,2.75-.58.79-1.52,1.34-2.5,1.3-.29-.01-.59-.07-.86.03-.32.13-.51.45-.71.74-.96,1.42-2.56,2.38-4.27,2.54-1.7.16-3.46-.47-4.67-1.68-1.38.49-3.04.34-4.2-.5-.05.73.12,1.48.56,2.07,1.08,1.45,3.22,1.82,4.93,1.21,1.21,1.21,2.97,1.84,4.67,1.68,1.7-.16,3.31-1.12,4.27-2.54.19-.29.39-.61.71-.74.27-.1.57-.04.86-.03.98.04,1.92-.51,2.5-1.3.58-.79.84-1.77.9-2.75.03-.48.02-.98.16-1.44.1-.34.29-.65.42-.97.53-1.27.26-2.8-.57-3.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M21.36,17.06c-1.29.54-2.5,1.47-3,2.78-.5,1.31-.1,3.01,1.13,3.68-.08.89-.13,1.89.43,2.59.51.62,1.37.82,2.16.9,1.23.12,2.74-.12,3.24-1.26.89.8,2.2,1.11,3.35.79,1.16-.32,2.12-1.25,2.48-2.4.12-.39.18-.81.36-1.18.12-.25.3-.47.43-.71.4-.72.4-1.64-.01-2.36-.41-.71-1.2-1.19-2.02-1.22-.05-.93-.62-1.82-1.45-2.25-1.06-.56-1.96-.08-3.01,0-1.45.12-2.7.03-4.1.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M31.94,19.91c-.25-.44-.66-.8-1.12-1.01-.05.2-.12.4-.23.58-.13.24-.31.46-.43.71-.18.37-.24.79-.36,1.18-.36,1.14-1.32,2.08-2.48,2.4-1.16.32-2.46,0-3.35-.79-.5,1.14-2,1.38-3.24,1.26-.43-.04-.87-.12-1.27-.28-.05.77,0,1.57.47,2.16.51.62,1.37.82,2.16.9,1.23.12,2.74-.12,3.24-1.26.89.8,2.2,1.11,3.35.79,1.16-.32,2.12-1.25,2.48-2.4.12-.39.18-.81.36-1.18.12-.25.3-.47.43-.71.4-.72.4-1.64-.01-2.36Z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 1065.93,
  y1: -293.77,
  x2: 1464.76,
  y2: 1968.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#e1f5fd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#95dcf7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#1cb6ef"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#00adee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#003c73"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "water"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "-159.89 -77.63 2691.05 -79 2691.05 1751.87 -159.89 1756 -159.89 -77.63"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "land"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "2582.97 1183.91 2582.97 1415.11 2531.45 1415.11 2531.45 1684.61 1958.75 1684.61 1958.75 1684.5 -7.05 1684.5 -7.05 -11.79 2519.56 -11.79 2520.88 752.13 1595.45 753.23 1595 665.16 1410.93 665.06 1410.93 713.16 1254.6 713.16 1254.6 806.96 1229.5 806.96 1229.5 848.79 1204.84 848.79 1204.84 885.79 1182.38 885.79 1182.38 926.3 1160.8 926.3 1160.8 989.27 1149.79 989.27 1149.79 1046.96 1169.17 1046.96 1169.17 1076.9 1192.07 1076.9 1192.07 1109.05 1216.29 1109.05 1216.29 1138.12 1260.33 1138.12 1260.33 1196.24 1608.22 1196.24 1608.22 1280.35 2073.02 1280.35 2073.02 1297.53 2405.94 1297.53 2405.94 1183.91 2582.97 1183.91"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 462.15,
  y: 6.04,
  width: 615.63,
  height: 509.94
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "266.63 29.82 266.63 529.2 -.23 529.2 -.23 165.9 180.76 165.9 180.76 29.82 266.63 29.82"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "1204.84 687.62 1204.84 713.16 1132.62 713.16 1132.62 654.15 1160.8 654.15 1160.8 687.62 1204.84 687.62"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 1132.62,
  y: 696.87,
  width: 49.76,
  height: 16.29
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "1132.62 713.16 1132.62 696.87 1101.79 696.87 1101.79 687.62 1132.62 687.62 1132.62 654.15 1160.8 654.15 1160.8 713.16 1132.62 713.16"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 1161.24,
  y: 696.87,
  width: 43.6,
  height: 16.29
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 1192.07,
  y: 692.46,
  width: 12.77,
  height: 20.7
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "1410.93 654.15 1410.93 665.06 1179.3 664.94 1160.8 665.73 1132.62 666.94 1132.62 654.15 1410.93 654.15"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "1410.93 654.15 1410.93 665.06 1179.3 664.94 1160.8 665.73 1160.8 654.15 1410.93 654.15"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 1169.17,
  y: 1207.69,
  width: 22.9,
  height: 2.21
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 1169.17,
  y: 1207.69,
  width: 22.9,
  height: 2.21
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 1258.56,
  y: 1196.24,
  width: 1.77,
  height: 26.87
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 1258.56,
  y: 1196.24,
  width: 1.77,
  height: 26.87
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Road"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1234.15,1075.78s-.06.05-.1.05c-.07-.01-.15-.01-.22-.03l.32-.02Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1233.83,1075.8l-.44.03-.02-.08c.16.02.31.04.46.05Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 695.98,
  y: 554.3,
  width: 5.29,
  height: 1.32
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 695.98,
  y: 554.3,
  width: 5.29,
  height: 1.32
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-11",
  points: "1480.3 547.28 1473.35 555.62 1354.48 555.62 1362.5 554.11 1402.8 543.76 1451.35 545.08 1480.3 547.28"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M857.28,608.56l-8.92.04c4.61-.5,8.92-.04,8.92-.04Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-11",
  points: "1480.3 547.28 1473.35 555.62 1354.48 555.62 1362.5 554.11 1402.8 543.76 1451.35 545.08 1480.3 547.28"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 2084.47,
  y: 656.82,
  width: 1.98,
  height: 10.57
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 2070.93,
  y: 741.7,
  width: 13.54,
  height: 9.25
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 2070.93,
  y: 741.7,
  width: 13.54,
  height: 9.25
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 1626.6,
  y: 730.03,
  width: 10.35,
  height: 12.99
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 2114.28,
  y: 179.78,
  width: 11.89,
  height: 84.61
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1851.6,99.25h-14.75v-14.53h14.72c.01,4.65.02,9.51.03,14.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M2470.98,84.72v14.53h-3.32c.05-5.05.09-9.91.13-14.53h3.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1852.13,264.39h-7.35v-14.54h7.29c.02,4.87.04,9.72.06,14.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1852.07,249.85h-7.29v14.54h7.35c-.02-4.82-.04-9.67-.06-14.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M2114.28,249.85v14.54h11.89v-14.54h-11.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M2428.12,1583.96v-260.26h101.84v-21.13h-1037.07v281.39h-440.69v-41.28h227.23v-26.43h-151.93v-799.26h-31.71v799.26h-76.62v67.71h-275.63v-869.89c6.31-17.12,16.2-40.11,16.2-40.11v-.67c3.38-6.2,12.3-17.33,17.17-22.45,4.19-4.41,13.92-13.38,18.94-17.4,5.5-4.4,19.84-13.56,26.86-17.39,2.42-1.32,6.17-2.43,10.13-4.19.46-.2,3.98-.86,8.07-1.76h318.9v-16.95h-416.27v-37.53h610.94l-37.55,7.07-55.82,10.9-101.29,19.6v16.95l39.53-4.84,96.44-21.8s44.31-15.79,58.79-11.89c6.61,1.78,19.25,11.43,20.48,18.17,1.72,9.43-27.98,54.02-32.29,60.44h-190.99v13.21h340.02s-50.87,47.06-57.8,48.93c-1.94.53-9.35.55-9.36.55-36.94.09-170.04.03-170.04.03v11.01h133.79v22.64h3.72v-22.64h37.32v-.05s6.31-.14,8.53-.97c21.85-8.11,71.94-59.5,71.94-59.5h116.81v75.3h10.24v-71.34h210.05v74.31h-220.29v11.89h873.25v-11.89h-415.49v9.25h-13.54v-9.25h-211.04v-74.31h211.04v74.31h13.54v-186.08h446.52v-29.06h-374.43v-141.95h314.42c4.18,0,7.92-5.62,7.92-9.25,0-87.4-.44-262.2-.44-349.6,0-16.84-14.36-16.35-22.01-16.35-150.94,0-553.44.08-603.75,0-15.58-.02-15.85.97-15.85,10.57v401.62h15.85s-.28-73.45-.57-157.21h262.15v-14.54h-262.21c-.07-23.27-.16-47.04-.23-70.01l262.44-.06h29.06s0,70.07,0,70.07h-17.17v14.54h17.17v262.17h-17.17v-262.17h-11.89v262.17H695.98l-379.4,10.56H-401.85v64.74s978.19-1.68,985.44.76c13.44,4.51,33.12,19.27,39.73,24.78,10.29,8.58,23.45,22.91,28.18,29.28,5.4,7.27,12.95,24.08,14.11,31.37,1.94,12.15.9,615.3.3,895.91H-239.07v43.6h904.89c-.13,60.14-.22,97.23-.22,97.23h77.94v-97.23h1808.88v-43.6h-124.3ZM2464.4,368.56s-3.58,4.18-6.06,4.18c-70.49,0-271.05-.02-301.78-.02v-108.33h309.13c-.65,50.51-1.04,92.57-1.29,104.17ZM2465.87,249.85h-309.31v-70.08l310.37-.07c-.41,23.37-.76,47.37-1.06,70.15ZM2466.77,164.01l-310.21-.02v-64.74h311.1c-.2,19.33-.48,41.54-.89,64.76ZM2114.28,163.99h-262.49c-.08-23.25-.14-45.29-.19-64.74h262.68v64.74ZM1851.57,84.72c-.05-20.07-.08-36.43-.08-47.1,0-1.34-1.65-11.06,12.06-11.06,87.52,0,447.72-1.1,598.26-1.1,5.92,0,6.28-.34,6.28,7.76,0,3-.05,22.82-.3,51.5h-616.22ZM2126.17,163.99v-64.74h17.17v64.74h-17.17ZM1859.89,555.62h211.04v101.2h-211.04v-101.2ZM1636.95,555.62h210.05v101.2h-210.05v-101.2ZM1473.35,555.62h153.36v94.6l-232.06-.11,78.7-94.49ZM2412.27,1583.96h-898.24v-260.26h898.24v260.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1851.84,179.84h-5.74v-15.86h5.69c.02,5.23.03,10.52.05,15.86Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 1447.12,
  y: 100.57,
  width: 328.95,
  height: 13.21
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 1647.93,
  y: -52.68,
  width: 14.53,
  height: 157.21
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 1447.12,
  y: -47.39,
  width: 11.89,
  height: 153.25
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M2938.66-68.58s-1125.87,2.86-1588.51,6.45c-42.61.33-44.77.34-63.91,1.72-5.45.4-19.76,1.04-24.61,3.56-7.59,3.97-13.7,12.83-13.87,18.5-2.31,78.27-6.05,209.06-7.48,314.96-.44,32.82,11.23,44.94,16.34,53.11,4.35,6.96,8.9,13.57,13.6,18.02,7.06,6.68,14.47,11.96,16.84,18.49,6.61,18.17,0,73.33,0,73.33l13.47.46s6.14-60.72-.92-79.07c-2.68-6.97-10.77-13.21-18.16-22.13-10.55-12.72-27.49-36.9-27.41-47.56.01-1.83.03-3.74.05-5.74h524.48c0,18.87,0,31.85-.01,35.84-.03,14.84-25.95,43.12-40.79,43.1-47.51-.06-154.8-1.34-201.91-1.1-21.14.1-23.78-3.3-24,23.89-.28,35.01,0,140.04,0,140.04h11.89s.01-106.9,0-140.04c0-11.56.22-11.78,13.87-11.78,51.52,0,150.11.61,200.15.88,20.03.11,53.89-31.93,54-54.99.42-85.48.07-327.3.01-368.02,485.06-3,1146.88-4.55,1146.88-4.55v-17.37ZM1778.57,269.67h-524.23c1.07-57.5,4.64-156.09,7.35-226.44,1.2-31.05-.06-77.62,4.57-82.24,5.51-5.51,45.05-2.62,78.6-3.31,80.81-1.64,242.77-3.07,433.7-4.26.01,35.64.03,222.91.01,316.25Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-11",
  points: "2478.96 25.93 2478.9 25.93 2478.9 14.7 2478.96 25.93"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1851.84,179.84h-5.74v-15.86h5.69c.02,5.23.03,10.52.05,15.86Z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "buildings"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-7",
  points: "2374.11 474.04 2473.85 472.34 2474.51 504.76 2528.68 503.11 2528.02 399.4 2374.11 402.7 2374.11 474.04"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-6",
  points: "2220.97 466.86 2319.17 466.2 2318.73 414.68 2219.76 415.58 2221.11 466.97"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-8",
  points: "1131.98 46.18 1180.61 46.11 1180.5 86.38 1131.84 86.82"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-8",
  points: "1189.06 -14.71 1215.39 -14.68 1215.28 5.24 1189.06 5.14"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-8",
  points: "1191.28 12.95 1226.29 12.95 1226.55 85.68 1190.62 85.45"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 2323.25,
  y: 624.54,
  width: 113.28,
  height: 8.92
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 2322.26,
  y: 544.28,
  width: 192.88,
  height: 18.17
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 2234.2,
  y: 1464.54,
  width: 138.72,
  height: 69.36
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 2434.34,
  y: 1224.76,
  width: 134.75,
  height: 65.39
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 2191.59,
  y: 1347.62,
  width: 31.71,
  height: 60.11
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 2226.11,
  y: 1347.62,
  width: 31.71,
  height: 60.11
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 2261.45,
  y: 1347.95,
  width: 31.71,
  height: 60.11
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 2296.12,
  y: 1347.62,
  width: 31.71,
  height: 60.11
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "2389.76 1408.39 2339.56 1408.72 2338.89 1338.7 2389.43 1338.37 2389.76 1408.39"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 844.4,
  y: 998.85,
  width: 16.84,
  height: 138.72
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 781.98,
  y: 993.9,
  width: 18.83,
  height: 145.65
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 907.81,
  y: 1363.47,
  width: 107.01,
  height: 112.95
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 922.67,
  y: 1167.29,
  width: 101.06,
  height: 120.88
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 948.44,
  y: 980.02,
  width: 64.4,
  height: 26.75
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 976.18,
  y: 1030.56,
  width: 34.68,
  height: 35.67
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 894.93,
  y: 857.16,
  width: 22.79,
  height: 116.92
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 891.96,
  y: 1007.77,
  width: 25.76,
  height: 135.74
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 813.68,
  y: 705.57,
  width: 45.58,
  height: 105.03
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 770.09,
  y: 851.22,
  width: 93.14,
  height: 93.14
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 883.04,
  y: 686.74,
  width: 65.39,
  height: 27.74
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 956.36,
  y: 768.98,
  width: 100.07,
  height: 73.32
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 968.25,
  y: 863.11,
  width: 47.56,
  height: 63.41
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 1053.46,
  y: 1111.8,
  width: 24.77,
  height: 90.17
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 1048.51,
  y: 1228.72,
  width: 31.71,
  height: 87.19
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 784.95,
  y: 1389.23,
  width: 38.64,
  height: 52.51,
  transform: "translate(703.91 -209.44) rotate(26.07)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 785.94,
  y: 1178.19,
  width: 13.87,
  height: 90.17
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 772.07,
  y: 1317.9,
  width: 12.88,
  height: 38.64
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 797.83,
  y: 1316.9,
  width: 12.88,
  height: 40.62
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 1596.44,
  y: 1453.64,
  width: 118.9,
  height: 100.07
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 1786.67,
  y: 1476.43,
  width: 162.5,
  height: 102.06
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 1314.05,
  y: 1230.7,
  width: 127.82,
  height: 59.45
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 1311.02,
  y: 678.57,
  width: 23.78,
  height: 22.9
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 1583.2,
  y: 401.78,
  width: 210.06,
  height: 54.17
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "trees"
}, /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(89.29 936.95) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(79.72 891.45) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(.45 941.64) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(-.58 892.85) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(341.97 933.87) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(378.45 907.66) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(417.23 889.9) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(417.03 939.3) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(460.84 913.22) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(332.39 888.36) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(43.54 924.87) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(388.5332 1005.3017) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(425.02 979.1) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(463.8 961.34) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(463.5953 1010.7322) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(592.92 915.62) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(378.96 959.8) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(438.0651 1073.7272) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(474.5492 1047.5231) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(510.7779 1005.2502) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(513.1272 1079.1578) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(561.5354 1036.227) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(428.4907 1028.2232) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(392.6166 1055.1578) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(349.2222 1078.4161) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(348.191 1029.6259) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(52.7773 1058.9223) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(9.383 1082.1807) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(8.3518 1033.3904) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(50.7447 1143.4573) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(57.8837 1101.816) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(145.3392 1152.8026) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1.85 988.89) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(219.3977 1153.6256) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(397.0082 1145.1113) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(433.4922 1118.9073) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(472.2741 1101.1449) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(515.8827 1124.4622) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(387.4337 1099.6074) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(351.5596 1126.5419) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(230.3516 1190.4165) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(269.1335 1172.6542) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(4.5896 1122.9302) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(312.7421 1195.9714) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(3.8167 1201.7922) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(483.0242 1187.3328) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(51.3499 1187.5502) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(565.4146 1192.8877) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(436.9656 1168.0329) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(406.7085 1195.9887) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(3.0577 1169.9089) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(98.843 1175.1281) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(357.4767 1171.3184) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(193.5899 1204.0479) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(183.1946 1172.087) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(103.0801 1199.2324) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(476.3567 1142.0409) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(361.4631 1200.7643) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(481.72 881.26) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(538.82 880.52) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(590.17 882.04) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(462.24 979.3) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(507.26 919) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(512.05 964.97) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(551.68 960.52) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(595.5192 1099.6024) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(595.5138 1002.7848) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(523.2339 1038.3359) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(550.3471 1079.3555) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(594.1596 1053.2759) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(592.86 953.87) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(596.6524 1145.98) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(554.95 993.94) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(558.7576 1155.2171) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(553.1026 1124.66) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(555.91 917.32) rotate(-27.9) scale(1.14 1.11)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(602.6345 1193.0855) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(521.2929 1165.0196) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(454.0505 1196.6036) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(524.405 1196.2576) rotate(-27.9017) scale(1.1425 1.1137)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(229.9717 1294.7534) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(232.6406 1338.1759) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(232.4566 1382.7532) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(349.1608 1296.9184) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(242.3417 1415.9544) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(275.0356 1377.806) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(277.1556 1444.5024) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(320.8407 1405.7605) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(240.2886 1464.3443) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(279.6423 1485.3865) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(249.9898 1542.1228) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(324.3414 1547.1357) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(243.9729 1501.25) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(248.8147 1265.9151) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(300.3454 1265.2481) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(346.6844 1266.6215) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(231.231 1354.3837) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(271.8594 1299.9684) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(276.1829 1341.4583) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(311.9509 1337.4445) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(351.5087 1462.9523) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(351.5038 1375.5812) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(286.2762 1407.6635) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(310.744 1444.6809) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(350.2817 1421.1458) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(349.1085 1331.4371) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(352.5313 1504.8048) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(314.8957 1367.6014) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(318.3339 1513.1407) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(313.2306 1485.565) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(315.7676 1298.4579) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(357.9297 1547.3142) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(284.5246 1521.9867) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(223.8431 1550.489) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(287.3331 1550.1767) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1441.6028 672.4744) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1405.88 672.6513) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1419.2562 692.3026) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1392.1736 691.4769) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1334.5241 586.0074) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1298.8013 586.1842) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1320.1041 611.12) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1285.0949 605.0099) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1245.8173 601.6036) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1218.9019 606.6245) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1232.278 626.2758) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1205.1955 625.4502) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(832.28 620.84) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(801.46 625.92) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(815.21 644.19) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(777.41 644.11) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(845.1 644.8) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(863 621.18) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(925.84 619.22) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(895.03 624.3) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(908.78 642.57) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(938.67 643.18) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(956.57 619.57) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1018.8417 617.9768) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(988.03 623.05) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1001.7795 641.3279) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1031.6668 641.9354) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1049.5695 618.3213) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(878.13 644.36) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(968.15 644.23) rotate(-27.9) scale(.76 .74)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1067.4855 639.954) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1149.4478 616.8289) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1113.7251 617.0057) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1127.1012 636.6571) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1100.0186 635.8314) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1174.1801 628.2554) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1082.8984 618.8164) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1184.1438 612.2643) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1268.4667 626.0117) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1297.7974 627.1834) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1266.5314 595.0366) rotate(-27.9017) scale(.7598 .7407)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1131.6156 1255.9127) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1157.0499 1256.4333) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1140.2129 1280.1022) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1161.7316 1294.6252) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1175.483 1271.3276) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1167.016 1341.3041) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1133.107 1334.8706) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1139.7554 1305.1155) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1178.852 1316.5096) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1177.2402 1379.8334) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1145.7162 1399.8354) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1188.2733 1357.1856) rotate(-27.9017) scale(.3785)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1166.8449 1452.7568) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1172.3711 1480.25) rotate(-27.9017) scale(.5691 .5548)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1131.5384 1474.0052) rotate(-27.9017) scale(.441 .4299)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1134.6739 1447.2451) rotate(-27.9017) scale(.4679 .4561)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1188.4923 1403.5521) rotate(-27.9017) scale(.3578)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(992.1039 1514.1169) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(972.5067 1511.5675) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(993.2217 1557.4412) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(991.4057 1534.2409) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1157.4609 1562.2098) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1173.9362 1553.8876) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1199.4775 1557.8509) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1259.9993 1555.7556) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1448.2849 1554.328) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1470.9653 1554.4977) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1303.4041 1560.0528) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1223.8843 1559.394) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1242.8921 1559.1272) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1283.5876 1557.4106) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1323.8828 1558.0207) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(1341.5937 1552.9199) rotate(-27.9017) scale(.3956)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(-3.3393 1296.2848) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(-.6705 1339.7074) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(-.8545 1384.2846) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(115.8497 1298.4498) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(9.0307 1417.4858) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(41.7245 1379.3375) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(43.8446 1446.0339) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(87.5296 1407.2919) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(6.9776 1465.8757) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(46.3313 1486.9179) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(16.6787 1543.6542) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(91.0303 1548.6672) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(10.6619 1502.7814) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(15.5037 1267.4465) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(67.0343 1266.7795) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(113.3734 1268.1529) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(-2.08 1355.9151) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(38.5484 1301.4998) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(42.8718 1342.9898) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(78.6399 1338.9759) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(118.1976 1464.4837) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(118.1927 1377.1126) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(52.9652 1409.195) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(77.433 1446.2123) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(116.9706 1422.6773) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(115.7974 1332.9685) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(119.2203 1506.3362) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(81.5846 1369.1328) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(85.0228 1514.6721) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(79.9196 1487.0964) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(82.4566 1299.9893) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(124.6187 1548.8456) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(51.2136 1523.5181) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(54.022 1551.7082) rotate(-27.9017) scale(1.031 1.0051)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(192.0004 1288.1741) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(152.1706 1309.5219) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(151.2241 1264.7394) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(194.9115 1375.0888) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(193.965 1330.3063) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(200.198 1417.1708) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(160.3681 1438.5187) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(159.4216 1393.7361) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(198.3323 1494.7619) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(204.8849 1456.5411) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(153.4537 1352.8889) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(155.9685 1475.9209) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(155.2591 1548.305) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(198.8878 1535.233) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}), /*#__PURE__*/React.createElement("use", {
  width: 44.68,
  height: 44.27,
  transform: "translate(154.5624 1519.0407) rotate(-27.9017) scale(1.0486 1.0223)",
  xlinkHref: "#Tree_1_Small"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "TaiChung_Marina",
  "data-name": "TaiChung Marina"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "1416.56 897.37 1416.56 903.47 1354.84 903.47 1354.77 897.34 1387.83 897.36 1387.83 877.77 1361.57 877.77 1361.55 874.11 1387.83 874.11 1387.83 854.54 1361.58 854.54 1361.56 850.88 1387.83 850.88 1387.83 831.31 1361.57 831.33 1361.54 828.26 1387.83 828.26 1387.83 808.09 1361.52 808.09 1361.49 804.43 1387.83 804.43 1387.83 784.88 1361.57 784.86 1361.56 781.82 1387.83 781.82 1387.83 761.65 1361.57 761.62 1361.56 758.58 1384.17 758.59 1384.16 735.34 1362.27 728.42 1349.91 728.39 1349.98 748.19 1346.28 748.18 1346.32 728.36 1330.92 728.23 1330.97 748.18 1327.94 748.18 1327.94 728.2 1312.58 728.08 1312.58 748.19 1309.56 748.19 1309.63 728.05 1289.46 727.88 1289.39 744.53 1286.36 744.53 1286.42 727.86 1272.33 727.74 1272.27 787.33 1292.48 787.31 1292.44 790.97 1272.27 790.94 1272.27 810.56 1299.18 810.54 1299.18 814.21 1272.28 814.21 1272.28 833.76 1299.18 833.77 1299.19 837.43 1272.27 837.43 1272.28 857 1299.04 856.96 1299.02 860.66 1272.28 860.66 1272.28 880.23 1299.18 880.24 1299.19 883.91 1272.28 883.9 1272.29 903.45 1305.91 903.47 1305.91 909.59 1268.02 909.56 1268.04 723.81 1362.64 723.86 1384.16 731.07 1388.43 731.07 1388.49 746.4 1395.07 746.4 1395.08 758.6 1412.91 758.59 1412.92 761.63 1392.74 761.63 1392.74 776.94 1412.88 776.92 1412.89 779.97 1392.73 779.96 1392.73 795.25 1412.9 795.26 1412.9 798.92 1392.73 798.91 1392.72 814.21 1412.88 814.22 1412.88 817.26 1392.72 817.25 1392.71 832.55 1412.88 832.55 1412.89 835.58 1392.71 835.57 1392.7 850.87 1412.88 850.88 1412.88 854.53 1392.7 854.53 1392.69 869.85 1412.87 869.85 1412.88 872.88 1392.69 872.88 1392.69 880.23 1412.89 880.24 1412.89 883.89 1392.69 883.89 1392.68 897.36 1416.56 897.37"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "bandp"
}, /*#__PURE__*/React.createElement("g", {
  id: "Pedestals"
}, /*#__PURE__*/React.createElement("g", {
  id: "P-1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin",
  className: "cls-5",
  d: "M1396.58,749.77h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1396.51,751.16s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1396.33,751.16s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1396.51,750.73c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1395.59,750.94s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1396.41,751.34s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1394.96,750.17s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1394.86,750.42h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1395.23,751.26c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.17,751.9c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1395.05,749.8h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1395.19,751.05s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1395.19,751.53s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline",
  className: "cls-4",
  d: "M1395.16,749.59c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1393.91,751.02c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1395.16,752.27c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-2",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1394.21,767.09h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-2",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.14,768.48s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.96,768.48s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.14,768.05c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.22,768.26s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.03,768.66s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1392.59,767.49s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1392.49,767.74h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1392.86,768.58c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-2",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-4",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1391.8,769.22c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1392.68,767.12h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-2",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.82,768.37s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-2",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.82,768.85s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-2",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1392.78,766.91c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1391.54,768.34c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1392.78,769.59c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-3",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1394.16,785.04h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-3",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.1,786.44s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.92,786.44s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.1,786.01c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.17,786.22s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.99,786.62s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1392.54,785.45s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1392.45,785.7h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1392.82,786.54c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-3",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-5",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1391.76,787.18c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1392.64,785.08h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-3",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.77,786.33s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-3",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.77,786.8s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-3",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1392.74,784.87c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1391.5,786.3c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1392.74,787.55c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-4",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1394.17,803.62h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-4",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.1,805.02s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.92,805.02s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.1,804.59c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.18,804.8s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394,805.19s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1392.55,804.02s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1392.45,804.28h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1392.82,805.12c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-4",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-6",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1391.76,805.75c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1392.64,803.66h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-4",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.78,804.9s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-4",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.78,805.38s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-4",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1392.74,803.45c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1391.5,804.87c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1392.74,806.12c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-5",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1394.18,822.38h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-5",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.11,823.77s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.93,823.77s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.12,823.35c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.19,823.55s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.01,823.95s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1392.56,822.78s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1392.47,823.03h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1392.84,823.88c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-5",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-7",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1391.78,824.51c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1392.65,822.42h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-5",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.79,823.66s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-5",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.79,824.14s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-5",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1392.76,822.2c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1391.51,823.63c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1392.76,824.88c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-6",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1394.15,840.43h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-6",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.09,841.83s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.91,841.83s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.09,841.4c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.16,841.61s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.98,842.01s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1392.53,840.84s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1392.44,841.09h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1392.81,841.93c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-6",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-8",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1391.75,842.57c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1392.63,840.47h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-6",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.76,841.72s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-6",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.76,842.19s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-6",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1392.73,840.26c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1391.48,841.69c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1392.73,842.94c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-7"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-7",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1394.15,859.62h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-7",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.09,861.01s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.91,861.01s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.09,860.59c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.16,860.79s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.98,861.19s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1392.53,860.02s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1392.44,860.27h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1392.81,861.11c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-7",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-9",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1391.75,861.75c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1392.63,859.65h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-7",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.76,860.9s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-7",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.76,861.38s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-7",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1392.73,859.44c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1391.48,860.87c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1392.73,862.12c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-8"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-8",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1394.26,889.26h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-8",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.2,890.65s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.02,890.65s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.2,890.23c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1393.27,890.43s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1394.09,890.83s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1392.64,889.66s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1392.55,889.91h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1392.92,890.76c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-8",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-10",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1391.86,891.39c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1392.74,889.3h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-8",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.87,890.54s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-8",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1392.87,891.02s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-8",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1392.84,889.08c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1391.59,890.51c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1392.84,891.76c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-9"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-9",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1388.13,899.83h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-9",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.06,901.22s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.88,901.22s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.06,900.8c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.14,901s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.96,901.4s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1386.51,900.23s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1386.41,900.48h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1386.78,901.33c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-9",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-11",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1385.72,901.96c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1386.6,899.87h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-9",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1386.74,901.11s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-9",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1386.74,901.59s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-9",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1386.7,899.65c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1385.46,901.08c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1386.7,902.33c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-10"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-10",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1389.2,887.2h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-10",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.13,888.59s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.95,888.59s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.13,888.16c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.21,888.37s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.03,888.77s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1387.58,887.6s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1387.49,887.85h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1387.85,888.69c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-10",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-12",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1386.79,889.33c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1387.67,887.23h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-10",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.81,888.48s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-10",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.81,888.96s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-10",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1387.78,887.02c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1386.53,888.45c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1387.78,889.7c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-11"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-11",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1389.28,861.43h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-11",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.21,862.83s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.03,862.83s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.22,862.4c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.29,862.61s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.11,863.01s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1387.66,861.84s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1387.57,862.09h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1387.94,862.93c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-11",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-13",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1386.88,863.57c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1387.75,861.47h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-11",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.89,862.72s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-11",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.89,863.19s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-11",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1387.86,861.26c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1386.61,862.69c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1387.86,863.94c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-12"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-12",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1389.2,838.73h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-12",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.13,840.12s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.95,840.12s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.13,839.7c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.21,839.9s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.03,840.3s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1387.58,839.13s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1387.49,839.38h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1387.85,840.22c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-12",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-14",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1386.79,840.86c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1387.67,838.76h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-12",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.81,840.01s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-12",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.81,840.49s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-12",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1387.78,838.55c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1386.53,839.98c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1387.78,841.23c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-13"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-13",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1389.26,815.72h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-13",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.19,817.11s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.01,817.11s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.19,816.69c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.27,816.89s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.08,817.29s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1387.64,816.12s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1387.54,816.37h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1387.91,817.22c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-13",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-15",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1386.85,817.85c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1387.73,815.76h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-13",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.86,817s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-13",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.86,817.48s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-13",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1387.83,815.54c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1386.59,816.97c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1387.83,818.22c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-14"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-14",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1389.25,792.08h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-14",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.18,793.48s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389,793.48s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.19,793.05c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.26,793.26s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.08,793.65s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1387.63,792.48s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1387.54,792.74h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1387.91,793.58c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-14",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-16",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1386.85,794.22c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1387.72,792.12h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-14",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.86,793.36s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-14",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.86,793.84s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-14",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1387.83,791.91c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1386.58,793.33c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1387.83,794.58c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-15"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-15",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1389.23,769.5h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-15",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.16,770.89s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.98,770.89s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.17,770.47c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1388.24,770.67s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1389.06,771.07s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1387.61,769.9s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1387.52,770.15h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1387.89,771c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-15",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-17",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1386.83,771.63c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1387.7,769.54h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-15",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.84,770.78s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-15",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1387.84,771.26s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-15",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1387.81,769.32c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1386.56,770.75c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1387.81,772c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-16"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-16",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1340.39,726.42h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-16",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1340.32,727.81s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1340.14,727.81s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1340.32,727.39c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1339.4,727.59s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1340.22,727.99s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1338.77,726.82s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1338.67,727.07h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1339.04,727.92c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-16",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-18",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1337.98,728.55c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1338.86,726.46h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-16",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1339,727.7s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-16",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1339,728.18s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-16",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1338.96,726.24c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1337.72,727.67c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1338.96,728.92c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-17"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-17",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1321.89,726.75h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-17",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1321.82,728.14s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1321.64,728.14s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1321.83,727.72c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1320.9,727.92s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1321.72,728.32s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1320.27,727.15s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1320.18,727.4h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1320.55,728.25c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-17",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-19",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1319.49,728.88c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1320.36,726.79h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-17",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1320.5,728.03s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-17",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1320.5,728.51s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-17",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1320.47,726.57c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1319.22,728c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1320.47,729.25c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-18"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-18",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1300.59,726.48h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-18",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1300.52,727.87s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1300.34,727.87s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1300.52,727.44c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1299.6,727.65s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1300.42,728.05s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1298.97,726.88s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1298.88,727.13h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1299.24,727.97c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-18",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-20",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1298.18,728.61c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1299.06,726.51h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-18",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1299.2,727.76s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-18",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1299.2,728.24s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-18",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1299.17,726.3c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1297.92,727.73c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1299.17,728.98c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-19"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-19",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1281.05,726.37h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-19",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1280.98,727.76s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1280.8,727.76s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1280.98,727.33c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1280.06,727.54s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1280.88,727.94s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1279.43,726.77s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1279.33,727.02h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1279.7,727.86c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-19",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-21",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1278.64,728.5c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1279.52,726.4h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-19",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1279.66,727.65s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-19",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1279.66,728.13s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-19",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1279.62,726.19c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1278.38,727.62c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1279.62,728.87c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-20"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-20",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1273.67,775.41h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-20",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.6,776.8s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.42,776.8s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.61,776.38c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.68,776.59s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.5,776.98s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1272.05,775.81s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1271.96,776.06h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1272.33,776.91c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-20",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-22",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1271.27,777.54c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1272.14,775.45h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-20",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.28,776.69s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-20",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.28,777.17s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-20",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1272.25,775.23c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1271,776.66c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1272.25,777.91c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-21"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-21",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1273.73,798.75h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-21",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.66,800.14s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.48,800.14s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.66,799.72c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.74,799.92s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.56,800.32s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1272.11,799.15s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1272.01,799.4h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1272.38,800.25c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-21",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-23",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1271.32,800.88c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1272.2,798.79h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-21",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.34,800.03s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-21",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.34,800.51s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-21",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1272.3,798.57c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1271.06,800c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1272.3,801.25c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-22"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-22",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1273.73,822.26h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-22",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.66,823.65s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.48,823.65s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.66,823.22c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.74,823.43s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.56,823.83s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1272.11,822.66s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1272.01,822.91h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1272.38,823.75c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-22",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-24",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1271.32,824.39c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1272.2,822.29h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-22",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.34,823.54s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-22",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.34,824.02s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-22",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1272.3,822.08c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1271.06,823.51c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1272.3,824.76c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-23"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-23",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1273.67,845.37h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-23",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.6,846.77s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.42,846.77s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.61,846.34c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.68,846.55s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.5,846.95s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1272.05,845.78s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1271.96,846.03h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1272.33,846.87c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-23",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-25",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1271.27,847.51c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1272.14,845.41h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-23",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.28,846.66s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-23",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.28,847.13s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-23",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1272.25,845.2c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1271,846.63c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1272.25,847.88c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-24"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-24",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1273.73,868.6h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-24",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.66,870s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.48,870s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.66,869.57c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.74,869.78s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1273.56,870.18s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1272.11,869s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1272.01,869.26h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1272.38,870.1c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-24",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-26",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1271.32,870.74c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1272.2,868.64h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-24",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.34,869.88s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-24",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1272.34,870.36s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-24",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1272.3,868.43c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1271.06,869.86c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1272.3,871.11c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "P-25"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pin-25",
  "data-name": "Pin",
  className: "cls-5",
  d: "M1288.15,907.63h0c-.37-.39-.89-.61-1.43-.61h0c-.54,0-1.06.21-1.43.61-.76.93-.34,1.8-.32,1.84h0c.49.89,1.65,3.02,1.67,3.04.03.05.08.06.13.04.01,0,.02-.02.03-.03h0l1.68-3.05h0s.44-.91-.32-1.84Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon-25",
  "data-name": "Icon"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1288.08,909.03s.01.03.03.03h.01s.03,0,.03-.03h0v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1287.9,909.03s.01.03.03.03h.01s.03,0,.03-.03v-.1h-.07v.1h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1288.08,908.6c-.15-.77-.9-1.27-1.67-1.12-.77.15-1.27.9-1.13,1.67.12.62.64,1.09,1.28,1.15.04,0,.08,0,.12,0,.42,0,.82-.19,1.1-.51.05-.05.07-.12.06-.19-.01-.07-.05-.13-.11-.16-.07-.04-.14-.06-.22-.06-.12,0-.23.05-.31.13-.11.12-.31.13-.43.01h-.02c-.17-.19-.45-.19-.62-.02h0s0,0,0,0c-.03.03-.06.05-.1.07-.03.01-.05.05-.03.09.01.03.05.05.09.03,0,0,0,0,0,0h0s.09-.05.13-.09c.12-.12.31-.13.43-.02h0s.01.01.01.02c.17.17.45.17.62,0h0c.06-.06.14-.1.22-.1.05,0,.1.01.15.04.02.01.04.04.05.07,0,.03,0,.06-.02.08-.45.55-1.27.62-1.81.16-.55-.45-.62-1.27-.16-1.81.45-.54,1.27-.62,1.81-.16.22.19.37.44.43.72-.07.02-.11.08-.11.14v.15h.37v-.14c0-.07-.05-.13-.12-.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1287.16,908.81s-.03-.05-.06-.05c-.03,0-.06.03-.05.06,0,.03.03.05.06.05.03,0,.06-.03.06-.06h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1287.98,909.2s-.08-.05-.11-.08c-.08-.08-.2-.13-.31-.13-.06,0-.11.01-.16.03l.12-.33s0-.04,0-.06c-.01-.02-.03-.03-.05-.03l-.28-.06v-.26c0-.05-.04-.1-.1-.1h-.08v-.15s-.03-.08-.08-.08h-.13v-.04s-.01-.04-.03-.04h-.06s-.03.02-.03.04v.04h-.13s-.08.03-.08.08v.15h-.08c-.05,0-.1.04-.1.1v.26l-.28.06s-.04.01-.05.03c-.01.02-.01.04,0,.06l.17.47c-.05.04-.11.06-.17.06-.04,0-.07.03-.06.07,0,.03.03.06.06.06.11,0,.22-.04.3-.12h.01c.12-.13.31-.14.43-.03h0s.01.01.02.02c.17.17.44.17.62,0h0c.12-.13.31-.13.43-.02,0,0,.01.01.02.02.04.04.09.07.14.09.03.02.07,0,.09-.03.02-.03,0-.08-.03-.09h0ZM1286.53,908.03s0-.02.02-.02h.39s.02,0,.02.02h0v.15h-.42v-.15h0ZM1286.43,908.28h.61s.04.01.04.03c0,.02-.01.04-.03.04h-.62s-.04-.01-.04-.03c0-.02.01-.04.03-.04h0ZM1286.8,909.13c-.08-.08-.19-.13-.31-.13-.09,0-.18.02-.25.08l-.12-.35.62-.14.62.14-.16.44c-.05.04-.11.06-.18.06-.08,0-.17-.04-.22-.1Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Warning-25",
  "data-name": "Warning"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path-27",
  "data-name": "Path"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1285.74,909.76c-.05,0-.11-.01-.15-.04-.15-.09-.2-.28-.12-.43l1.01-1.69h0s.06-.08.1-.11c.15-.09.34-.04.43.11h0l1.02,1.69s.04.1.04.15c0,.08-.03.16-.09.22-.06.06-.14.1-.22.1h-2.02ZM1286.62,907.67h0s-1.01,1.7-1.01,1.7c-.04.08-.02.18.06.22.02.01.05.02.08.02h2.02c.09,0,.16-.08.16-.16,0-.03,0-.06-.02-.08l-1.01-1.69c-.05-.08-.15-.1-.22-.05-.02.01-.04.03-.05.05Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-2-25",
  "data-name": "Path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1286.76,908.91s-.08-.03-.08-.07v-.48s.03-.08.07-.08c.04,0,.08.03.08.07h0v.49s-.03.08-.07.08Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path-3-25",
  "data-name": "Path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1286.76,909.39s-.06-.02-.07-.05c-.01-.03,0-.06.02-.08,0,0,0,0,.01,0h.01s.01-.01.01-.01c.04,0,.08.02.09.06,0,0,0,.01,0,.01,0,0,0,.02,0,.03,0,.01,0,.02-.02.02-.01.02-.03.02-.05.02Z"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Offline-25",
  "data-name": "Offline",
  className: "cls-4",
  d: "M1286.72,907.46c-.79,0-1.44.64-1.44,1.43s.64,1.43,1.44,1.43,1.43-.64,1.43-1.44c0-.79-.64-1.43-1.43-1.43ZM1285.48,908.88c0-.69.56-1.24,1.24-1.24.31,0,.58.11.8.29l-1.75,1.76c-.18-.22-.29-.5-.29-.81ZM1286.72,910.13c-.31,0-.6-.12-.82-.31l1.75-1.75c.19.22.31.5.31.82,0,.68-.56,1.24-1.24,1.24Z"
}))));

function SvgOrganisation14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2499 1672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation14);
export default __webpack_public_path__ + "static/media/Organisation_14.dc1c7b4d.svg";
export { ForwardRef as ReactComponent };